module.exports = __webpack_public_path__ + "img/cc.9827265c.png";